import React from 'react'

export const ProductsContext = React.createContext(null)
export const RouteContext = React.createContext(null)
export const ShoppingListContext = React.createContext((null))